import styled from '@emotion/styled'

const StyledLabel = styled.label`
    margin-top: 1rem;
`;
export default StyledLabel;